/**
 * @module core/cache
 * @description In-memory caching utilities
 */

export { LRUCache, type LRUCacheOptions } from './lru-cache.js'
export type { CacheStats } from '@gzl10/nexus-sdk'
export { ManagedCacheImpl } from './managed-cache.js'
export { CacheManager, type CacheManagerOptions } from './cache-manager.js'
export { ScopedCacheManagerImpl } from './scoped-cache-manager.js'
export { RedisManagedCache } from './redis-managed-cache.js'
